<template>
  <swiper ref="mySwiper" :options="swiperOptions">
    <swiper-slide class="swiper-item" v-for="(v, i) in swiperSlides" :key="i">
      <!-- <img :src="v.src" /> -->
      <img
        @click="toDetail(v)"
        :src="v.thumbUrl"
        style="width: 100%;vertical-align: middle"
      />
    </swiper-slide>
    <div class="swiper-pagination" slot="pagination"></div>
  </swiper>
</template>

<script>
let vm = null;
import { mapGetters } from 'vuex';
import { searchGaoshanImg } from '@/api/school';
export default {
  name: 'SwiperCom',
  data() {
    return {
      swiperOptions: {
        autoplay: 2000,
        loop: true,
        resistanceRatio: 0,
        autoplayDisableOnInteraction: false,
        pagination: '.swiper-pagination',
        // pagination: {
        //   el: '.swiper-pagination',
        //   clickable: true,
        //   type: 'bullets'
        // },
        moveStartThreshold: 100,
        paginationClickable: true,
        // scrollbar: '.swiper-scrollbar'
        // // Some Swiper option/callback...
      },
      swiperSlides: [
        {
          src: '../assets/logo.png'
        },
        {
          src: '../assets/close.png'
        }
      ]
    };
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.$swiper;
    }
  },
  methods: {
    ...mapGetters(['getTerminalForChrome']),
    toDetail(val) {
      // this.$router.push({
      //   // path: `/detail?categorybelong=${val.categorybelong}&rec_id=${val.rec_id}`
      //   path: val.imgturnurl
      // })
      const a = document.createElement('a');
      a.href = val.imgturnurl;
      a.target = '_self';
      a.click();
    },
    _searchGaoshanImg() {
      searchGaoshanImg({ imgtype: '0' }).then(res => {
        if (res.status === 200) {
          this.swiperSlides = res.data.data;
        }
      });
    }
  },
  mounted() {
    console.log('Current Swiper instance object', this.swiper);
    // this.swiper.slideTo(1, 1000, false);
    this._searchGaoshanImg();
  },
  created() {
    vm = this;
    // console.log('vm', vm);
  }
};
</script>

<style>
.swiper-item {
  width: 100%;
}
</style>
